import React from 'react'
import Departments from 'src/app/Departments/Departments'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { departmentsRouteProps } from 'src/navigation/routeProps'

const DepartmentsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsDepartments,
  routeProps: departmentsRouteProps,
  component: <Departments />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default DepartmentsAppRoute
